import { useEffect, useState } from "react";
import { getBanks, nameEnquiry, outboundTransfer } from "../../../services/transactionServices";
import AmountScreen from "./AmountScreen";
import BankSelectScreen from "./BankSelectScreen";
import AccountNumberScreen from "./AccountNumberScreen";
import ConfirmScreen from "./ConfirmScreen";
import SuccessScreen from "./SuccessScreen";
import FailureScreen from "./FailureScreen";
import axios from "axios";


const Transfer = () => {
  const [step, setStep] = useState(1);

  const [amount, setAmount] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState("");
  const [bankName, setBankName] = useState("");
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const [loading, setLoading] = useState(false);
  const [successData, setSuccessData] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  

  // STEP 4 — Resolve beneficiary
 

  const completeTransfer = async () => {
    try {
      setLoading(true);

      const res = await outboundTransfer(selectedBank, bankName, accountNumber, beneficiaryName, amount, "transfer to " + beneficiaryName);
      console.log('outbound transer res', res)
      if(res.requestSuccessful){
        setSuccessData({
          amount,
          accountNumber,
          bank: banks.find((b) => b.code === selectedBank)?.name,
        });
        setStep(5);
      }else{
        setErrorMessage("Somwthing went wrong; crosscheck transaction history before you try again");
        setStep(6);
      }
      
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrorMessage(error.response?.data?.message || "Transfer failed");
      setStep(6);
    }
  };

  // STEP 3 — Fetch banks
  useEffect(() => {
      const loadBanks = async () => {
        try {
          const res = await getBanks(); 
          console.log('bank res',  res)
          if(res.requestSuccessful){
            setBanks(res.responseBody.data);
          }
          
        } catch (error) {
          console.log(error);
        }
      };
      loadBanks();
  }, []);

  useEffect(() =>{
    const resolveBeneficiary = async () => {
      try {
        setLoading(true);

        const res = await nameEnquiry( selectedBank, accountNumber);
      
        console.log(' name enquiry res', res)
        if(res.requestSuccessful){
          setBeneficiaryName(res.responseBody?.accountDetails?.beneficiaryAccountName);
          setStep(4);
        }
        
        setLoading(false);
      } catch (error) {
        setLoading(false);
        alert("Failed to resolve account");
      }
    };
    if(selectedBank){
      resolveBeneficiary();
    }
  }, [selectedBank])
  return (
    <div className="max-w-md mx-auto mt-6">
      {/* Step Screens */}
      {step === 1 && (
        <AmountScreen amount={amount} setAmount={setAmount} onNext={() => setStep(2)} />
      )}

      {step === 2 && (
        <AccountNumberScreen
          accountNumber={accountNumber}
          setAccountNumber={setAccountNumber}
          onNext={() => setStep(3)}
        />
      )}

      {step === 3 && (
        <BankSelectScreen
          banks={banks}
          onSelect={(bank) => {
            console.log("Selected bank:", bank);
            setSelectedBank(bank.code);
            setBankName(bank.name);
          }}
          setSelectedBank={setSelectedBank}
          // onNext={() => setTimeout(resolveBeneficiary, 4000)}       
        />
      )}

      {step === 4 && (
        <ConfirmScreen
          amount={amount}
          accountNumber={accountNumber}
          bankName={banks.find((b) => b.code === selectedBank)?.name}
          accountName={beneficiaryName}
          onConfirm={completeTransfer}
          loading={loading}
        />
      )}

      {step === 5 && <SuccessScreen data={successData} />}
      {step === 6 && <FailureScreen message={errorMessage} />}
    </div>
  );
};

export default Transfer;